import React, { useCallback, useEffect, useState } from "react";
import Report from "../../../models/Report";
import DataTable from "../dataTable";

const initialTable = {
    page: 1,
    term: "",
    sort: "percentage",
    order: "desc",
    limit: 25,
};

export default function MembershipTeeTimeRequestEngagement() {
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState(initialTable);
    const [totalRecords, setTotalRecords] = useState(0);
    const [data, setData] = useState([]);

    const getData = useCallback(async (params) => {
        setLoading(true);
        const response = await Report.membershipTeeTimeRequestEngagement(
            params,
        );
        setData(response.items);
        setTotalRecords(response.total);
        setTable(params);
        setLoading(false);
    }, []);

    useEffect(() => {
        getData(initialTable);
    }, [getData]);

    const headers = [
        { key: "membershipCategory", text: "Membership category" },
        { key: "totalMembers", text: "Total members" },
        { key: "activeMembers", text: "Members with requests" },
        { key: "percentage", text: "% with requests" },
    ];
    const tableData = data.map((item) => {
        const percentage = Number(item.percentage || 0);
        return {
            membershipCategory: {
                value: item.membershipCategory,
                search: item.membershipCategory,
            },
            totalMembers: {
                value: item.totalMembers,
                search: item.totalMembers,
            },
            activeMembers: {
                value: item.activeMembers,
                search: item.activeMembers,
            },
            percentage: {
                value: `${percentage.toFixed(2)}%`,
                search: percentage,
            },
        };
    });

    return (
        <>
            <h4>Membership category tee-time request engagement</h4>
            <p>
                The percentage of members in each membership category who have
                ever made a tee-time request.
            </p>
            <DataTable
                loading={loading}
                headers={headers}
                data={tableData}
                totalRecords={totalRecords}
                page={table.page}
                onChange={getData}
                searchTerm={table.term}
                sort={table.sort}
                order={table.order}
                limit={table.limit}
                sortOptions={[
                    { text: "% with requests", key: "percentage" },
                    {
                        text: "Membership category",
                        key: "membershipCategory",
                    },
                    { text: "Total members", key: "totalMembers" },
                    {
                        text: "Members with requests",
                        key: "activeMembers",
                    },
                ]}
                pagination
            />
        </>
    );
}
